module.exports = __webpack_public_path__ + "static/media/icon-notify-assigned.19d60640.svg";